<template>
  <div class="login-container">
    <!-- Fondo con círculos decorativos -->
    <!-- <div class="background-decoration">
      <div class="circle circle-1"></div>
      <div class="circle circle-2"></div>
      <div class="circle circle-3"></div>
      <div class="circle circle-4"></div>
      <div class="circle circle-5"></div> -->
      
      <!-- Líneas decorativas -->
     <!--  <svg class="decorative-lines" viewBox="0 0 1440 900" preserveAspectRatio="none">
        <path d="M0 700 Q360 600 720 650 T1440 550 L1440 900 L0 900 Z" fill="rgba(0,60,165,0.03)"/>
        <path d="M0 750 Q360 680 720 720 T1440 650 L1440 900 L0 900 Z" fill="rgba(0,60,165,0.05)"/>
      </svg>
    </div> -->

    <!-- Contenido principal -->
    <div class="login-content">
      <!-- Logo y marca -->
   


      <!-- Tarjeta de login -->
      <div class="login-card">
        <center><img src="@/assets/onest.jpeg" alt="Logo" class="logo-image" width="100" /></center>
        <br>
        <div class="card-header">
          <h2 class="card-title">CRM Dashboard Ejecutivo</h2>
          <p class="card-description">Iniciar sesión</p>
        </div>

        <form @submit.prevent="login" class="login-form">
          <!-- Campo de usuario -->
          <div class="form-field">
            <label for="email" class="field-label">
              <svg class="field-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                <circle cx="12" cy="7" r="4"/>
              </svg>
              Correo Electrónico
            </label>
            <div class="input-container">
              <input
                type="text"
                v-model="email"
                id="email"
                class="field-input"
                required
                placeholder="usuario@ejemplo.com"
                :class="{ 'has-error': error && !email }"
              />
              <div class="input-highlight"></div>
            </div>
          </div>

          <!-- Campo de contraseña -->
          <div class="form-field">
            <label for="password" class="field-label">
              <svg class="field-icon" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
              </svg>
              Contraseña
            </label>
            <div class="input-container">
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="password"
                id="password"
                class="field-input"
                required
                placeholder="••••••••"
                @keydown.enter="login"
                :class="{ 'has-error': error && !password }"
              />
              <button
                type="button"
                class="toggle-password"
                @click="showPassword = !showPassword"
                tabindex="-1"
              >
                <svg v-if="!showPassword" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                  <circle cx="12" cy="12" r="3"/>
                </svg>
                <svg v-else width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"/>
                  <line x1="1" y1="1" x2="23" y2="23"/>
                </svg>
              </button>
              <div class="input-highlight"></div>
            </div>
          </div>

          <!-- Opciones -->
          <div class="form-options">
            <label class="checkbox-label">
              <input type="checkbox" v-model="rememberMe" class="checkbox-input"/>
              <span class="checkbox-custom"></span>
              <span class="checkbox-text">Recordarme</span>
            </label>
           
          </div>

          <!-- Botón de login -->
          <button
            type="submit"
            class="btn-login"
            :disabled="loading"
          >
            <template v-if="!loading">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4"/>
                <polyline points="10 17 15 12 10 7"/>
                <line x1="15" y1="12" x2="3" y2="12"/>
              </svg>
              Ingresar al Sistema
            </template>
            <template v-else>
              <span class="spinner"></span>
              Verificando credenciales...
            </template>
          </button>
        </form>

        <!-- Mensaje de error -->
        <transition name="alert">
          <div v-if="error" class="alert-error" role="alert">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
            <div class="alert-content">
              <strong>Error de autenticación</strong>
              <p>{{ error }}</p>
            </div>
          </div>
        </transition>

        <!-- Footer -->
        <div class="card-footer">
          <div class="footer-divider">
            <span>¿Primera vez aquí?</span>
          </div>
          <p class="footer-text">
            Contacta al administrador del sistema para obtener tus credenciales de acceso
          </p>
        </div>
      </div>

      <!-- Pie de página -->
      <p class="copyright">
        © {{ currentYear }} CX Dashboard · Todos los derechos reservados
      </p>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { trackTrasRecarga } from "@/services/telemetry";

export default {
  name: "LoginDash",
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      error: null,
      showPassword: false,
      rememberMe: false,
      currentYear: new Date().getFullYear(),
      authURL:
        "https://g220992e7796ae2-db20220530220647.adb.mx-queretaro-1.oraclecloudapps.com/ords/crm_app/cxdemo/login",
    };
  },
  methods: {
    async login() {
      if (!this.email || !this.password) {
        this.error = "Por favor completa todos los campos requeridos.";
        return;
      }

      this.loading = true;
      this.error = null;

      try {
        // El handler de login (ORDS cxdemo) lee las credenciales como query
        // params, NO del body: con body JSON responde 200 con cuerpo vacío y el
        // front nunca vería clave_acceso. Ver docs/API.md → POST /login.
        const response = await axios.post(this.authURL, null, {
          params: {
            id_usuario: this.email,
            id_password: this.password,
            id_app: 13,
          },
        });

        if (Number(response.data.clave_acceso) === 1) {
          console.log("Login exitoso:", response.data);
          sessionStorage.setItem(
            "nombre_usuario",
            response.data.nombre_usuario || this.email
          );
          // El email de sesión es la llave con la que sesion() resuelve el
          // idColaborador y el rol desde CRM_COLABORADOR (scoping).
          sessionStorage.setItem("email", this.email);
          sessionStorage.setItem("profile", response.data.profile || "");
          sessionStorage.setItem("token", response.data.token || "");
          sessionStorage.setItem("token2", response.data.token2 || "");

          // Rol del usuario (admin | editor). El servicio agregó un nuevo campo;
          // se capta de forma tolerante por si el nombre difiere.
          const rol =
            response.data.rol ||
            response.data.role ||
            response.data.perfil ||
            response.data.profile ||
            "";
          sessionStorage.setItem("rol", rol);
          localStorage.setItem("rol", rol);

          if (this.rememberMe) {
            localStorage.setItem("remembered_email", this.email);
          }

          this.password = "";
          this.email = "";

          this.$emit("login-success", {
            nombre_usuario: sessionStorage.getItem("nombre_usuario"),
            token: sessionStorage.getItem("token"),
          });

          localStorage.setItem("token", sessionStorage.getItem("token"));
          trackTrasRecarga("login_exitoso", { origen: "formulario" });
          window.location.reload();

          if (this.$router) {
            this.$router.push("/");
          }
        } else {
          this.error = response.data.message || "Las credenciales proporcionadas no son válidas.";
        }
      } catch (err) {
        console.error("Error en login:", err);
        this.error = "No se pudo establecer conexión con el servidor. Intenta nuevamente.";
      } finally {
        this.loading = false;
      }
    },
  },
  mounted() {
    const remembered = localStorage.getItem("remembered_email");
    if (remembered) {
      this.email = remembered;
      this.rememberMe = true;
    }
  },
};
</script>

<style scoped>
/* ============================================
   VARIABLES CSS — definidas en .login-container para que el login use SIEMPRE
   su paleta clara (no se ve afectado por el modo oscuro global).
   ============================================ */
.login-container {
  --primary: #003CA5;
  --primary-dark: #002A7A;
  --primary-light: #1A5CC9;
  --secondary: #43B234;
  --secondary-light: #5CC94E;
  --white: #FFFFFF;
  --gray-100: #F0F4FA;
  --gray-200: #D4DFF0;
  --gray-300: #A0B8D8;
  --heading: #002A7A;
  --brand-text: #003CA5;
  --txt: #0A1628;
}

/* ============================================
   CONTENEDOR PRINCIPAL
   ============================================ */
.login-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(160deg, #F0F4FA 0%, #D4DFF0 30%, #FFFFFF 70%);
  position: relative;
  overflow: hidden;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* ============================================
   FONDO DECORATIVO
   ============================================ */
.background-decoration {
  position: absolute;
  width: 100%;
  height: 100%;
  overflow: hidden;
}

.circle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.08;
}

.circle-1 {
  width: 700px;
  height: 700px;
  background: var(--primary);
  top: -250px;
  right: -150px;
  animation: float1 25s ease-in-out infinite;
}

.circle-2 {
  width: 500px;
  height: 500px;
  background: var(--secondary);
  bottom: -150px;
  left: -100px;
  animation: float2 20s ease-in-out infinite;
}

.circle-3 {
  width: 350px;
  height: 350px;
  background: var(--primary-light);
  top: 40%;
  right: 20%;
  animation: float3 18s ease-in-out infinite;
}

.circle-4 {
  width: 250px;
  height: 250px;
  background: var(--secondary-light);
  top: 15%;
  left: 15%;
  animation: float4 22s ease-in-out infinite;
}

.circle-5 {
  width: 180px;
  height: 180px;
  background: var(--primary-dark);
  bottom: 25%;
  right: 30%;
  animation: float5 15s ease-in-out infinite;
}

.decorative-lines {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

@keyframes float1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  33% { transform: translate(50px, -40px) rotate(5deg); }
  66% { transform: translate(-30px, 20px) rotate(-3deg); }
}

@keyframes float2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  33% { transform: translate(-40px, 30px) rotate(-4deg); }
  66% { transform: translate(20px, -20px) rotate(3deg); }
}

@keyframes float3 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(30px, -30px) scale(1.1); }
}

@keyframes float4 {
  0%, 100% { transform: translate(0, 0) scale(1); }
  50% { transform: translate(-20px, 20px) scale(0.95); }
}

@keyframes float5 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  50% { transform: translate(25px, -25px) rotate(-5deg); }
}

/* ============================================
   CONTENIDO PRINCIPAL
   ============================================ */
.login-content {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 460px;
  padding: 20px;
}

/* ============================================
   SECCIÓN DE MARCA
   ============================================ */
.brand-section {
  text-align: center;
  margin-bottom: 32px;
  animation: fadeInDown 0.8s ease-out;
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.logo-wrapper {
  position: relative;
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
}

.logo-ring {
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 20px;
  background: linear-gradient(135deg, var(--primary), var(--primary-light));
  opacity: 0.1;
  animation: rotate 10s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.logo-inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 64px;
  height: 64px;
  background: var(--white);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(0, 60, 165, 0.12);
  padding: 8px;
}

.logo-inner svg {
  width: 100%;
  height: 100%;
}

.brand-title {
  font-size: 28px;
  font-weight: 700;
  color: var(--primary-dark);
  margin: 0 0 4px 0;
  letter-spacing: -0.5px;
}

.brand-subtitle {
  font-size: 13px;
  color: var(--gray-300);
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 2px;
  font-weight: 500;
}

/* ============================================
   TARJETA DE LOGIN
   ============================================ */
.login-card {
  background: #F7F7F7;
  border-radius: 20px;
  padding: 40px 32px;
  box-shadow: 
    0 20px 60px rgba(0, 42, 122, 0.08),
    0 0 0 1px rgba(0, 60, 165, 0.05);
  animation: fadeInUp 0.8s ease-out 0.2s both;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.card-header {
  text-align: center;
  margin-bottom: 32px;
}

.card-title {
  font-size: 22px;
  font-weight: 700;
  color: var(--primary-dark);
  margin: 0 0 8px 0;
}

.card-description {
  font-size: 14px;
  color: var(--gray-300);
  margin: 0;
}

/* ============================================
   FORMULARIO
   ============================================ */
.login-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.form-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.field-label {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
  color: var(--primary-dark);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.field-icon {
  color: var(--primary);
  flex-shrink: 0;
}

.input-container {
  position: relative;
}

.field-input {
  width: 100%;
  padding: 14px 44px 14px 16px;
  border: 2px solid var(--gray-200);
  border-radius: 12px;
  font-size: 15px;
  color: var(--primary-dark);
  transition: all 0.3s ease;
  background: var(--gray-100);
  outline: none;
  font-family: inherit;
}

.field-input:hover {
  border-color: var(--gray-300);
  background: var(--white);
}

.field-input:focus {
  border-color: var(--primary);
  background: var(--white);
  box-shadow: 0 0 0 4px rgba(0, 60, 165, 0.08);
}

.field-input::placeholder {
  color: var(--gray-300);
}

.field-input.has-error {
  border-color: #FF5D73;
  background: #FFF5F5;
}

.input-highlight {
  position: absolute;
  bottom: -2px;
  left: 50%;
  width: 0;
  height: 2px;
  background: var(--primary);
  transition: all 0.3s ease;
  transform: translateX(-50%);
  border-radius: 0 0 2px 2px;
}

.field-input:focus ~ .input-highlight {
  width: 100%;
}

.toggle-password {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  padding: 6px;
  color: var(--gray-300);
  transition: color 0.2s ease;
  display: flex;
  align-items: center;
}

.toggle-password:hover {
  color: var(--primary);
}

/* ============================================
   OPCIONES DEL FORMULARIO
   ============================================ */
.form-options {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.checkbox-label {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  user-select: none;
}

.checkbox-input {
  display: none;
}

.checkbox-custom {
  width: 18px;
  height: 18px;
  border: 2px solid var(--gray-200);
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  flex-shrink: 0;
}

.checkbox-input:checked ~ .checkbox-custom {
  background: var(--primary);
  border-color: var(--primary);
}

.checkbox-input:checked ~ .checkbox-custom::after {
  content: "✓";
  color: white;
  font-size: 12px;
  font-weight: bold;
  line-height: 1;
}

.checkbox-text {
  font-size: 14px;
  color: var(--primary-dark);
  font-weight: 500;
}

.link-forgot {
  font-size: 13px;
  color: var(--primary);
  text-decoration: none;
  font-weight: 600;
  transition: color 0.2s ease;
}

.link-forgot:hover {
  color: var(--primary-light);
  text-decoration: underline;
}

/* ============================================
   BOTÓN DE LOGIN
   ============================================ */
.btn-login {
  width: 100%;
  padding: 15px;
  background: linear-gradient(135deg, var(--primary), var(--primary-dark));
  color: var(--white);
  border: none;
  border-radius: 12px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  box-shadow: 0 4px 16px rgba(0, 60, 165, 0.2);
  letter-spacing: 0.3px;
}

.btn-login:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(0, 60, 165, 0.3);
  background: linear-gradient(135deg, var(--primary-light), var(--primary));
}

.btn-login:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 60, 165, 0.15);
}

.btn-login:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  transform: none;
  box-shadow: 0 2px 8px rgba(0, 60, 165, 0.1);
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-top-color: var(--white);
  border-radius: 50%;
  animation: spin 0.6s linear infinite;
  flex-shrink: 0;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* ============================================
   ALERTA DE ERROR
   ============================================ */
.alert-error {
  display: flex;
  gap: 12px;
  padding: 16px;
  background: #FFF5F5;
  border: 1px solid #FED7D7;
  border-left: 4px solid #FF5D73;
  border-radius: 10px;
  color: #C53030;
  margin-top: 8px;
}

.alert-error svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: #FF5D73;
}

.alert-content strong {
  display: block;
  font-size: 13px;
  margin-bottom: 4px;
}

.alert-content p {
  margin: 0;
  font-size: 13px;
  color: #9B2C2C;
}

.alert-enter-active {
  transition: all 0.3s ease-out;
}

.alert-leave-active {
  transition: all 0.2s ease-in;
}

.alert-enter-from {
  transform: translateY(-10px);
  opacity: 0;
}

.alert-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}

/* ============================================
   FOOTER DE LA TARJETA
   ============================================ */
.card-footer {
  margin-top: 28px;
  padding-top: 24px;
}

.footer-divider {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  color: var(--gray-300);
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 1px;
  font-weight: 600;
}

.footer-divider::before,
.footer-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: var(--gray-200);
}

.footer-text {
  font-size: 13px;
  color: var(--gray-300);
  text-align: center;
  margin: 0;
  line-height: 1.5;
}

/* ============================================
   COPYRIGHT
   ============================================ */
.copyright {
  text-align: center;
  margin-top: 32px;
  font-size: 12px;
  color: var(--gray-300);
  animation: fadeInUp 0.8s ease-out 0.4s both;
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 480px) {
  .login-card {
    padding: 32px 20px;
    border-radius: 16px;
  }

  .card-title {
    font-size: 20px;
  }

  .brand-title {
    font-size: 24px;
  }

  .logo-wrapper {
    width: 64px;
    height: 64px;
  }

  .logo-inner {
    width: 52px;
    height: 52px;
    padding: 6px;
  }

  .form-options {
    flex-direction: column;
    gap: 12px;
    align-items: flex-start;
  }

  .btn-login {
    padding: 14px;
    font-size: 14px;
  }
}
</style>